<template lang="pug">
section.twitch
  .content
    .twitch__logos
      img.twitch__logos-item.twitch__logos-item--cb(src="@/assets/images/cb-logo.svg" width="312")
      img.twitch__logos-item.twitch__logos-item--twitch(src="@/assets/images/twitch-logo.svg" width="220")

    .twitch__content
      .twitch__wrap
        h1.twitch__title(v-html="$t('twitch.title')")

        .twitch__region(v-for="region in regions", :key="region")
          a.button.button--corner.button--red.twitch__button(:href="getPromoLink(region)")
            span {{ getRegionName(region) }}
</template>

<script>
export default {
  name: "TwitchSelect",

  data() {
    return {
      regions: ["west", "asia"],
      region_links: {
        west: "https://conqblade.com/promo/twitchdrops/",
        asia: "https://www.conquerorsblade.com/activity/twitch",
      },
    };
  },

  methods: {
    getPromoLink(region) {
      return this.region_links[region];
    },

    getRegionName(region) {
      return this.$t(`twitch.${region}_region`);
    },
  },
};
</script>
